import { Navigate } from 'react-router-dom'
import { useAppContext } from '../context/useAppContext'

export default function SupabaseApp() {
  const { user, authLoading } = useAppContext()

  if (authLoading) {
    console.log('[APP REDIRECT] still loading auth...')
    return (
      <div
        style={{
          display: 'flex',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0f172a',
          color: 'white',
          fontSize: '18px'
        }}
      >
        Loading authentication...
      </div>
    )
  }

  if (!user?.isAuthenticated) {
    console.log('[APP REDIRECT] not authenticated, to /login')
    return <Navigate to="/login" replace />
  }

  if (user.role === 'tenant') {
    console.log('[APP REDIRECT] to tenant dashboard')
    return <Navigate to="/app/tenant/dashboard" replace />
  }

  console.log('[APP REDIRECT] to landlord dashboard')
  return <Navigate to="/app/landlord/dashboard" replace />
}